import { Box } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { api, podatki } from '../api/odjemalec';
import { Kartica, StanjeNalaganja } from '../postavitev/Podatki';
import { varnHtml } from '../postavitev/varnHtml';
import { GlavaZaslona, ZaslonSeznama } from '../seznam/Seznam';

/** Zgodovina sprememb – kot ChangesTab v Swingu: novosti po verzijah (isti zapis, prebere ga strežnik). */
export function Spremembe() {
  const spremembe = useQuery({
    queryKey: ['spremembe'],
    queryFn: ({ signal }) => podatki(api.GET('/api/spremembe', { signal })),
    staleTime: 60 * 60_000,
  });
  return (
    <ZaslonSeznama>
      <GlavaZaslona naslov="Zgodovina sprememb" opis="Novosti in popravki po posameznih verzijah programa." />
      <Kartica>
        {!spremembe.data ? (
          <StanjeNalaganja
            napaka={spremembe.error}
            ponovi={() => void spremembe.refetch()}
            naslov="Zgodovine sprememb ni bilo mogoče naložiti"
          />
        ) : (
          <Box
            className="spremembe"
            maw={900}
            dangerouslySetInnerHTML={{ __html: varnHtml(spremembe.data.besedilo ?? '') }}
          />
        )}
      </Kartica>
    </ZaslonSeznama>
  );
}
